export const GradingConstants = {
  // Route Tokens
  defaultApi: 'Grading',

//  APPLICATION: "application",
//  GROUP: "group",
//  OLDER_THAN: "olderThan",
//  ROLES: "roles",

  // Other constants
    UI: {
    ROOT_PATH: 'grading',
  }

} as const;
